import { normalize, schema } from 'normalizr'
import api from '@/api'

// TODO: modularize normalization
const fieldTypeSchema = new schema.Entity('fieldTypes')
// fieldTypeSchema.define({ subfieldtypes: [ fieldTypeSchema ] })
const partSchema = new schema.Entity('parts')
const partsSchema = new schema.Array(partSchema)
partSchema.define({ parts: partsSchema, fieldtype: fieldTypeSchema })
const templateSchema = new schema.Entity('templates', { root_parts: partsSchema })

const state = {
  parts: {},
  fieldTypes: {},
  template: {},
  viewArchived: false,
  viewIdentifiers: false,
  activePartId: null
}

const getters = {
  template: (state) => state.template,
  partById: (state) => (id) => state.parts[id],
  fieldTypeById: (state) => (id) => state.fieldTypes[id],
  activePartId: (state) => state.activePartId
}

const mutations = {
  clearTemplate(state) {
    state.template = {}
    state.parts = {}
    state.fieldTypes = {}
    state.activePartId = null
  },
  setActivePartId(state, id) {
    state.activePartId = id
  },
  setNestedTemplate(state, template) {
    let normalized = normalize(template, templateSchema)
    state.template = normalized.entities.templates[normalized.result]
    state.parts = { ...state.parts, ...normalized.entities.parts }
    state.fieldTypes = { ...state.fieldTypes, ...normalized.entities.fieldTypes }
  },
  setTemplate(state, template) {
    state.template = template
  },
  setNestedPart(state, part) {
    let normalized = normalize(part, partSchema)
    state.parts = { ...state.parts, ...normalized.entities.parts }
    state.fieldTypes = { ...state.fieldTypes, ...normalized.entities.fieldTypes }
  },
  setNestedFieldType(state, fieldType) {
    let normalized = normalize(fieldType, fieldTypeSchema)
    state.fieldTypes = { ...state.fieldTypes, ...normalized.entities.fieldTypes }
  }
}

const actions = {
  getTemplate({ commit }, templateId) {
    return new Promise((resolve, reject) => {
      api.formtemplate.formtemplate.get(templateId)
        .then(template => {
          commit('setNestedTemplate', template)
          resolve(template)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  saveTemplate({ commit }, template) {
    return new Promise((resolve, reject) => {
      api.formtemplate.formtemplate.save(template)
        .then(template => {
          commit('setNestedTemplate', template)
          resolve(template)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  saveSection({ commit }, section) {
    return new Promise((resolve, reject) => {
      api.formtemplate.section.save(section)
        .then(section => {
          commit('setNestedPart', section)
          resolve(section)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  moveSection({ commit }, { section, insert_before, toSection }) {
    return api.formtemplate.section.move(section, insert_before, toSection)
  },
  saveParagraph({ commit }, paragraph) {
    return new Promise((resolve, reject) => {
      api.formtemplate.paragraph.save(paragraph)
        .then(paragraph => {
          commit('setNestedPart', paragraph)
          resolve(paragraph)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  moveParagraph({ commit }, { paragraph, insert_before, toSection }) {
    return api.formtemplate.paragraph.move(paragraph, insert_before, toSection)
  },
  savePagebreak({ commit }, pagebreak) {
    return new Promise((resolve, reject) => {
      api.formtemplate.pagebreak.save(pagebreak)
        .then(pagebreak => {
          commit('setNestedPart', pagebreak)
          resolve(pagebreak)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  movePagebreak({ commit }, { pagebreak, insert_before, toSection }) {
    return api.formtemplate.pagebreak.move(pagebreak, insert_before, toSection)
  },
  saveEsignature({ commit }, esignature) {
    return new Promise((resolve, reject) => {
      api.formtemplate.esignature.save(esignature)
        .then(esignature => {
          commit('setNestedPart', esignature)
          resolve(esignature)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  moveEsignature({ commit }, { esignature, insert_before, toSection }) {
    return api.formtemplate.esignature.move(esignature, insert_before, toSection)
  },
  saveQuestion({ commit }, question) {
    return new Promise((resolve, reject) => {
      api.formtemplate.question.save(question)
        .then(question => {
          commit('setNestedPart', question)
          resolve(question)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  moveQuestion({ commit }, { question, insert_before, toSection }) {
    return api.formtemplate.question.move(question, insert_before, toSection)
  },
  saveFieldType({ commit }, fieldType) {
    return new Promise((resolve, reject) => {
      api.formtemplate.fieldType.save(fieldType)
        .then(fieldType => {
          commit('setNestedFieldType', fieldType)
          resolve(fieldType)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
